import React from 'react'
import type { LeadField } from '@widget/types'

interface LeadFormStubProps {
  tenantId: string
  conversationId?: string
  prefillData?: Record<string, any>
  fields?: LeadField[]
  onSubmit: () => void
  onCancel: () => void
}

/**
 * Placeholder for the widget's LeadForm. The internal dashboard chat runs in
 * support-only mode, which never renders the sales lead form, so the real
 * component (which pulls in the widget's public API client) is aliased to
 * this stub at build time — see the `@/components/LeadForm` alias in
 * vite.config.ts and tsconfig.json.
 */
export const LeadForm: React.FC<LeadFormStubProps> = (_props) => null
